import styled from 'styled-components';
import { ALIGNMENT, Menu, MenuItemOption } from 'ui/menu';
import { CountBadge } from 'ui/menu/Styled';
import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { Table } from 'ui/icons';
import { TruncateTooltip } from 'ui/utility/truncate/TruncateTooltip';
import { TipPlacement } from 'ui/tooltip';
import { useTranslation } from '../../../hooks';
import { useUserFieldsContext } from '../../../contexts/userFields';
import { useUsersTableColumnsContext } from '../../../contexts/usersTableColumns';
import { pxToRem } from 'utils/convert';

const Trigger = ({ numSelected = 0 }: { numSelected: number }) => {
  const { t } = useTranslation();
  return (
    <SecondaryButton size={BUTTON_SIZES.LARGE}>
      <Table />
      {t('button.columns')}
      <CountBadge>{numSelected}</CountBadge>
    </SecondaryButton>
  );
};

const StyledMenu = styled(Menu)`
  [data-test='menu-segmentation-filter-columns'] {
      max-width: unset; 
      width: ${pxToRem(672)};
  }
  [data-test="menu-item-wrapper"] {
    > * > * > div {
      width: 100%;
    }
  }
`;

export const FilterColumnsDropdown = () => {
  const { prioritizedUserFields } = useUserFieldsContext();
  const prioritizedFieldIds = prioritizedUserFields.map((field) => field.field);
  const { selectedColumns, setSelectedColumns } = useUsersTableColumnsContext();
  const options: MenuItemOption[] = prioritizedUserFields.map(
    (userField): MenuItemOption => ({
      content: (
        <TruncateTooltip
          name={userField.title}
          tooltipProps={{ placement: TipPlacement.Left, delayDuration: 300 }}
          textOnly
          maxWidth={600}
        />
      ),
      label: userField.title,
      id: userField.field,
    }),
  );
  const handleSelectionChange = (selectedId: string) => {
    const newSelectedColumns = [...selectedColumns];
    if (selectedColumns.includes(selectedId)) {
      newSelectedColumns.splice(selectedColumns.indexOf(selectedId), 1);
    } else {
      newSelectedColumns.push(selectedId);
    }
    // Make sure column order matches dropdown order
    const reorderedSelectedColumns = newSelectedColumns.sort(
      (a, b) => prioritizedFieldIds.indexOf(a) - prioritizedFieldIds.indexOf(b),
    );
    setSelectedColumns(reorderedSelectedColumns);
  };

  return (
    <StyledMenu
      defaultSelectedOptionIds={selectedColumns}
      handleSelectionChange={handleSelectionChange}
      horizontalAlignment={ALIGNMENT.RIGHT}
      isSelectMenu
      hasFilter
      options={options}
      id="segmentation-filter-columns"
    >
      <Trigger numSelected={selectedColumns.length} />
    </StyledMenu>
  );
};
